import { unifyParams } from '../../../utils/unifyParams'
import apinode from '../../apinode'

class EmbalagensService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/embalagens/${this.idconta}`)

    return response.data
  }

  async getById(id) {
    const response = await apinode.get(`/embalagens/${id}/${this.idconta}`)

    return response.data
  }

  async search({ type, text }) {
    const url = unifyParams(`/embalagens/search/${this.idconta}`, [
      {
        key: type,
        value: text,
      },
    ])

    const response = await apinode.get(url)

    return response.data
  }

  async create(data) {
    await apinode.post(`/embalagens/${this.idconta}`, data)
  }

  async update(id, data) {
    await apinode.put(`/embalagens/${id}/${this.idconta}`, data)
  }

  async delete(id) {
    await apinode.delete(`/embalagens/${id}/${this.idconta}`)
  }
}

export default new EmbalagensService()
